<template>
  <div class="causeStepLog" v-if='totals>0'>
    <div class="h2">操作记录</div>
    <div class="ztable">
      <div class="thead">
        <div class="td">时间</div>
        <div class="td">操作人员</div>
        <div class="td">操作记录</div>
        <div class="td">时间</div>
        <div class="td">操作人员</div>
        <div class="td">操作记录</div>
      </div>
      <div class="tr">
        <div class="th" v-for='i in list' :key="i.id">
          <div class="td">
            {{i.create_time}}
          </div>
          <div class="td">
            <Normap :tit='i.username'></Normap>
            <!-- <a-tooltip placement="topLeft">
              <template slot="title">
                {{i.data || i.content}}
              </template>
              {{i.username || (i.manager?i.manager.uname:'') || ''}}  
            </a-tooltip> -->
          </div>
          <div class="td">
            <Normap :tit='i.title'></Normap>
          </div>
        </div>
      </div>
      <!-- <table class="table" v-if='list[0].list.length>0'>
        <thead>
          <td>时间</td>
          <td>操作人员</td>
          <td>操作记录</td>
        </thead>
        <tbody>
          <tr v-for='i in list[0].list'>
            <td>{{i.create_time}}</td>
            <td>{{i.username || '/'}}</td>
            <td>{{i.title}}</td>
          </tr>
        </tbody>
      </table>
      <table class="table" v-if='list[1].list.length>0'>
        <thead>
          <td>时间</td>
          <td>操作人员</td>
          <td>操作记录</td>
        </thead>
        <tbody>
          <tr v-for='i in list[1].list'>
            <td>{{i.create_time}}</td>
            <td>{{i.username || '/'}}</td>
            <td>{{i.title}}</td>
          </tr>
        </tbody>
      </table> -->
    </div>
    <div class="pages" v-if='totals>10'>
      <a-pagination v-model="form.page" :total="totals" show-less-items @change='nturn' />
    </div>
  </div>
</template>
<script>
import { causeStepLog } from '@/server/collection'
export default {
  name:'CauseStepLog',
  props: {
    type: Boolean,
    id: Number
  },
  data() {
    return {
      form: {
        page: 1,
        limit: 10
      },
      // list: {
      //   0: { list: [] },
      //   1: { list: [] }
      // },
      list: [],
      totals: 0
    }
  },
  created() {
    this.getList()
  },
  methods: {
    endsub(i) {
      this.$emit('sub', i)
    },
    nturn(val) {
      this.form.page = val;
      this.getList()
    },
    getList() {
      causeStepLog(Object.assign(this.type ? { loan_id: this.id } : { cause_id: this.id }, this.form), this.type).then(res => {
        // console.log('ttt', res)
        // let arr = {
        //   0: { list: [] },
        //   1: { list: [] }
        // }
        // res.list.map((ele, index) => {
        //   if (index < 5) {
        //     arr[0].list.push(ele)
        //   } else {
        //     arr[1].list.push(ele)
        //   }
        // })
        this.totals = res.count
        this.list = res.list
        // console.log('list',this.list);
        
      })
    }
  }
}
</script>
<style lang="less" scoped>
.causeStepLog {
  padding-bottom: 20px;
  background: #fff;
  .h2 {
    margin-bottom: 20px;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 62px;
    border-bottom: 1px solid #efefef;
    padding: 0 20px;
    font-size: 16px;
    font-weight: bold;
    color: #0e2949;
  }
}
.ztable {
  overflow: hidden;
  padding: 0 20px;
  // justify-content: space-between;
  // table {
  //   float: left;
  //   margin-right: 20px;
  //   border: 1px solid #ebebeb;
  //   max-width: 48%;
  //   thead {
  //     td {
  //       text-align: center;
  //       padding: 0;
  //       border-right: 1px solid #ebebeb;
  //     }
  //   }
  //   tbody {
  //     tr {
  //       td {
  //         text-align: center;
  //         padding: 0;
  //         border-right: 1px solid #ebebeb;
  //       }
  //     }
  //   }
  // }
  .thead {
    width: 100%;
    background: #f4f5f9;
    border: 1px solid #efefef;
    display: flex;
    .td {
      flex: 1;
      line-height: 36px;
      text-align: center;
      width: 33.3%;
      font-size: 14px;
      font-weight: bold;
      color: #102b4b;
      // &:nth-child(4) {
      //   border-left: #efefef 1px solid;
      // }
    }
  }
  .tr {
    display: flex;
    flex-wrap: wrap;
    .th {
      width: 50%;
      display: flex;
      border-left: 1px solid #efefef;
      border-bottom: 1px solid #efefef;
      .td {
        flex: 1;
        width: 33.3%;
        text-align: center;
        line-height: 40px;
        background: #ffffff;
        border-right: 1px solid #efefef;
        padding: 0 10px;
        font-size: 14px;
        color: #102b4b;
      }
      &:nth-child(2n) {
        border-left: 0 none;
      }
    }
  }
}
</style>